import styled from 'styled-components';
import darkBlue from '../../../theme/colors/darkBlue';
import { scrollbarStyle } from '../Styled';

export const ScatterPlotWrapper = styled('div')<{ hideFirstRowAndColumnLabel?: boolean }>`
    min-width: fit-content;
    position: relative;
    & > div {
        font-family: inherit;
        width: 100%;
        min-width: fit-content;
        padding-bottom: 1.2rem;

        svg > g {
            & > g:nth-child(4) > g:first-of-type,
            & > g:nth-child(3) > g:first-of-type,
            & > g:nth-child(3) > g:last-of-type,
            & > g:nth-child(4) > g:last-of-type {
                display: none;
            }
            text {
                fill: ${darkBlue};
                font-size: 12px !important;
                font-weight: 600 !important;
                width: 50px !important;
            }
        }
        ${scrollbarStyle}
    }
`;

export const RangeDiv = styled('div')`
    position: absolute;
    bottom: 6rem;
    left: 2rem;
    max-width: 7rem;
`;

export const EmptyGraphWrapper = styled(`div`)<{ height: string }>`
    width: 100%;
    padding: 3rem 5rem;
    box-sizing: border-box;
    position: absolute;
    height: ${({ height }) => height};
    top: 0;
`;

export const EmptyGraphLayoutWrapper = styled(`div`)<{ height: string }>`
    width: 100%;
    height: ${({ height }) => height};
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const EmptyGraphTextWrapper = styled(`div`)`
    width: 30rem;
    text-align: center;
`;
